import React from 'react'

// Material UI Components
import { makeStyles, List, ListItem, Typography, Button, DialogContent, DialogActions, Hidden } from '@material-ui/core';

// Material UI Custom Component Style
const useStyles = makeStyles(theme => ({
    Selected: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover' : {
            background: theme.palette.primary.main,
            color: theme.palette.common.white,
        }
    },
    Container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    Button: {
        background: theme.palette.error.main,
        color: theme.palette.common.white,
        '&:hover' : {
            background: theme.palette.error.dark,
            color: theme.palette.common.white,
        }
    },
  }));

export default function Leaderboard( { leaderboard, handleDialogClose, onClickClearLeaderboard } ) {
    const Style = useStyles();

    // This method will cut the name to 5 characters long and will add the ... at then end to signify that there are hidden characters
    const handleCutName = (name) => {
        const nameArray = name.split("");
        const newNameArray = nameArray.slice(0, 5);
        const newName = newNameArray.join("");

        return `${newName}...`
    }

    return (
        <React.Fragment>
            <DialogContent style={{maxHeight: '500px'}}>
                <List>
                    {
                        leaderboard.map((item, index) => {
                            return(
                                <ListItem 
                                    key={item.id} 
                                    className={item.id === leaderboard[0].id ? `${Style.Selected} ${Style.Container}` : Style.Container}
                                    divider
                                >
                                    <div className={Style.Container} style={{justifyContent: 'stretch'}}>
                                        <Typography variant="body1" color="textSecondary" style={{marginRight: '0.5rem', fontWeight: 'normal'}}>{`${index + 1})`}</Typography>
                                        <Hidden smUp>
                                            <Typography variant="h6">{item.name.length > 5 ? handleCutName(item.name) : item.name}</Typography>
                                        </Hidden>
                                        <Hidden xsDown>
                                            <Typography variant="h6">{item.name}</Typography>
                                        </Hidden>
                                    </div>
                                    <Typography variant="body1" style={{marginLeft: '2.25rem'}}>{item.time}s</Typography>
                                </ListItem>
                            );
                        })
                    }
                </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="inherit">
                        Cancel
                    </Button>
                    <Button className={Style.Button} variant="contained" onClick={() => onClickClearLeaderboard()} disabled={leaderboard.length <= 0 ? true : false} >
                        Clear
                    </Button>
                </DialogActions>
        </React.Fragment>
    )
}
